function prependChild<T extends Node>(parent: T, element: Node): void {
    if (parent.firstChild) {
        parent.insertBefore(element, parent.firstChild);
    } else {
        parent.appendChild(element);
    }
}

// ----------------------------------------------------------------------------

export default prependChild;
